import { useEffect, useState } from "react";

export default function ProgressBar({
  value = 0,
  max = null,
  barColor = "#000000",
  animate = false,
}) {
  const hasMax = max !== null && max !== undefined;
  const percentage = hasMax ? Math.min((value / max) * 100, 100) : 100;

  const [animatedPercentage, setAnimatedPercentage] = useState(
    animate ? 0 : percentage,
  );

  useEffect(() => {
    if (!animate) {
      setAnimatedPercentage(percentage);
      return;
    }

    setAnimatedPercentage(0);

    const timeout = setTimeout(() => {
      setAnimatedPercentage(percentage);
    }, 100);

    return () => clearTimeout(timeout);
  }, [percentage, animate]);

  return (
    <div className="w-full">
      <div
        className={
          hasMax
            ? "h-2 w-full overflow-hidden rounded-sm bg-gray-200"
            : "h-2 w-full overflow-hidden rounded-sm border border-dashed border-gray-400 bg-gray-100"
        }
        role="progressbar"
        aria-valuenow={hasMax ? value : undefined}
        aria-valuemin={hasMax ? 0 : undefined}
        aria-valuemax={hasMax ? max : undefined}
        aria-label={hasMax ? `${value} of ${max} sold` : "Unlimited inventory"}
      >
        <div
          className={
            hasMax
              ? animate
                ? "h-full rounded-sm transition-all duration-700 ease-out"
                : "h-full rounded-sm"
              : "h-full rounded-sm bg-transparent"
          }
          style={{
            width: hasMax ? `${animatedPercentage}%` : "100%",
            backgroundColor: hasMax ? barColor : "transparent",
          }}
        />
      </div>
    </div>
  );
}